<template>
    <div class="governance-form6">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="A organização mantém registro adequado de suas atividades financeiras e econômicas?"
                label-for="hasRegister"
            >
                <b-form-radio-group
                    name="hasRegister"
                    v-model="form.hasRegister.selected"
                    :options="form.hasRegister.options"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['mantem_registro'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['mantem_registro'].value"
                />
            </b-form-group>

            <b-form-group
                label="As demonstrações contábeis são analisadas pelo conselho fiscal e aprovadas pelo conselho deliberativo e/ou assembleia geral (no caso das associações)?"
                label-for="isAnalyzed"
            >
                <b-form-radio-group
                    name="isAnalyzed"
                    v-model="form.isAnalyzed.selected"
                    :options="form.isAnalyzed.options"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['contabeis_analisadas'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['contabeis_analisadas'].value"
                />
            </b-form-group>

            <b-form-group
                label="As demonstrações contábeis são auditadas por organização independente contratada pelo conselho deliberativo?"
                label-for="isAudit"
            >
                <b-form-radio-group
                    name="isAudit"
                    v-model="form.isAudit.selected"
                    :options="form.isAudit.options"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['contabeis_auditadas'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['contabeis_auditadas'].value"
                />
            </b-form-group>

            <b-form-group
                label="A missão da organização está contemplada pelo objeto social da organização estabelecido no estatuto?"
                label-for="isContemplatedMission"
            >
                <b-form-radio-group
                    name="isContemplatedMission"
                    v-model="form.isContemplatedMission.selected"
                    :options="form.isContemplatedMission.options"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform &&
                                getAuthorizationData &&
                                getAuthorizationData['organizacao_contemplada'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['organizacao_contemplada'].value"
                />
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'GovernanceForm5' })"
                    v-if="!showFooterButtons"
                >
                    Voltar
                </b-button>

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons">
                    Próximo
                </b-button>

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('GovernanceForm5')">Voltar</b-button>

                    <b-button :variant="'primary'" @click="changeRegisterForm('GovernanceForm7')">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { GovernanceApi } from '../../api/governance'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const governanceApi = new GovernanceApi()

export default {
    components: { DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            progress: 85.87,
            isUpdate: false,
            governance: null,
            isDisabled: null,
            message: null,
            authorizationData: null,
            form: {
                hasRegister: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                },
                isAnalyzed: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                },
                isAudit: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                },
                isContemplatedMission: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 2 },
                        { text: 'Não se aplica', value: 3 }
                    ]
                }
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        fetchRead() {
            const data = this.receiveData

            this.form.hasRegister.selected = data.mantem_registro
            this.form.isAnalyzed.selected = data.contabeis_analisadas
            this.form.isAudit.selected = data.contabeis_auditadas
            this.form.isContemplatedMission.selected = data.organizacao_contemplada

            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            this.usuario = JSON.parse(localStorage.getItem('usuario'))
            this.setIsLoading(true)

            axios
                .all([governanceApi.getGovernance()])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.governance = data
                        this.form.hasRegister.selected = data.mantem_registro
                        this.form.isAnalyzed.selected = data.contabeis_analisadas
                        this.form.isAudit.selected = data.contabeis_auditadas
                        this.form.isContemplatedMission.selected = data.organizacao_contemplada

                        this.setProgress(data.percentual)
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit() {
            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress

            const data = {
                ...this.governance,
                mantem_registro: this.form.hasRegister.selected,
                contabeis_analisadas: this.form.isAnalyzed.selected,
                contabeis_auditadas: this.form.isAudit.selected,
                organizacao_contemplada: this.form.isContemplatedMission.selected,
                percentual: currentProgress
            }

            this.setIsLoading(true)
            const request = this.isUpdate ? governanceApi.updateGovernance(data) : governanceApi.nextGovernance(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.isUpdate ? this.changeStatusDisabled(true) : this.$router.push({ name: 'GovernanceForm7' })
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getGovernance(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.hasRegister.options = this.form.hasRegister.options.filter(
                    x => Number(this.form.hasRegister.selected) === x.value
                )

                this.form.isAnalyzed.options = this.form.isAnalyzed.options.filter(
                    x => Number(this.form.isAnalyzed.selected) === x.value
                )

                this.form.isAudit.options = this.form.isAudit.options.filter(
                    x => Number(this.form.isAudit.selected) === x.value
                )

                this.form.isContemplatedMission.options = this.form.isContemplatedMission.options.filter(
                    x => Number(this.form.isContemplatedMission.selected) === x.value
                )
            }
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/register-governance-forms/GovernanceForm6.vue